
import { motion } from "framer-motion";
import { useTranslation } from 'react-i18next';

export const LoanDetailsSection = () => {
  const { t } = useTranslation();

  const LOAN_ROWS = [
    { label: t('plans_detail.safety_net.loan.row1_label'), value: t('plans_detail.safety_net.loan.row1_value') },
    { label: t('plans_detail.safety_net.loan.row2_label'), value: t('plans_detail.safety_net.loan.row2_value') },
    { label: t('plans_detail.safety_net.loan.row3_label'), value: t('plans_detail.safety_net.loan.row3_value') },
    { label: t('plans_detail.safety_net.loan.row4_label'), value: t('plans_detail.safety_net.loan.row4_value') },
    { label: t('plans_detail.safety_net.loan.row5_label'), value: t('plans_detail.safety_net.loan.row5_value') },
  ];

  return (
    <>
      <motion.section
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="text-2xl font-bold mb-4 text-white">{t('plans_detail.safety_net.loan.title')}</h2>
        <div className="overflow-x-auto mb-8">
          <table className="min-w-full border-collapse">
            <tbody>
              {LOAN_ROWS.map((row) => (
                <tr key={row.label} className="border-b border-white/10">
                  <th className="px-4 py-3 text-left text-[#c9a84c] font-semibold text-sm w-1/3 bg-white/5">
                    {row.label}
                  </th>
                  <td className="px-4 py-3 text-white/75 text-sm">{row.value}</td>
                </tr>
              ))}
              <tr className="border-b border-white/10">
                <th className="px-4 py-3 text-left text-[#c9a84c] font-semibold text-sm w-1/3 bg-white/5">
                  {t('plans_detail.safety_net.loan.special_label')}
                </th>
                <td className="px-4 py-3 text-white/75 text-sm">
                  <ul className="list-disc pl-5 space-y-1">
                    <li>{t('plans_detail.safety_net.loan.special_item1')}</li>
                    <li>{t('plans_detail.safety_net.loan.special_item2')}</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="border border-white/10 bg-white/5 p-6 rounded-xl mb-8">
          <h3 className="font-bold text-lg mb-3 text-white">{t('plans_detail.safety_net.loan.notes_title')}</h3>
          <ul className="list-disc pl-6 space-y-2 text-white/65">
            <li>{t('plans_detail.safety_net.loan.note1')}</li>
            <li>{t('plans_detail.safety_net.loan.note2')}</li>
            <li>{t('plans_detail.safety_net.loan.note3')}</li>
          </ul>
        </div>
      </motion.section>
    </>
  );
};
